(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvDashboardSettingList', function () {
            
            return {
                templateUrl: 'app/dashboard/dashboard-setting-list.tmpl.html',
                scope: {
                    label: '@',
                    configuration: '='
                },
                controller: ['$q', '$scope', '$location', 'DashboardSettingsService', 'EntityTemplatesService', 'DialogService', 'NavigationAidService', function ($q, $scope, $location, DashboardSettingsService, EntityTemplatesService, DialogService, NavigationAidService) {
                    var drvCtrl = this;
                    drvCtrl.dashboardSettings = [];
                    drvCtrl.dashboardSettingCount = 0;
                    drvCtrl.currentPage = 1;
                    drvCtrl.newDashboardSetting = newDashboardSetting;
                    drvCtrl.deleteDashboardSetting = deleteDashboardSetting;
                    drvCtrl.getDashboardSettingName = getDashboardSettingName;
                    drvCtrl.getDashboardSettingDescription = getDashboardSettingDescription;
                    drvCtrl.updateList = updateList;
                    drvCtrl.loadCount = loadCount;
                    drvCtrl.orderDashboardSettings = orderDashboardSettings;
                    drvCtrl.close = close;
                    drvCtrl.loading = false;
                    drvCtrl.error = null;
                    drvCtrl.showDeleted = false;
                    Object.defineProperty(drvCtrl, 'titleText', { get: getTitleText });

                    activate();

                    function activate() {
                        $scope.$watch('drvCtrl.currentPage', function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                updateList();
                            }
                        });

                        $scope.$watch('drvCtrl.showDeleted', function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                updateList();
                                loadCount();
                            }
                        });

                        drvCtrl.loading = true;

                        var loadPromises = [];
                        loadPromises.push(loadEntityTemplates());

                        $q.all(loadPromises).then(function () {
                            updateList();
                            loadCount();
                        });
                    }

                    function updateList(newPage) {
                        if (updateList.currentPromise === undefined) {
                            updateList.currentPromise = null;
                        }
                        drvCtrl.loading = true;
                        var searchName = "";

                        if (!angular.isUndefined(newPage)) {
                            drvCtrl.currentPage = newPage;
                        }

                        if (!angular.isUndefined(drvCtrl.searchName)) {
                            searchName = angular.copy(drvCtrl.searchName);
                        }

                        
                        var getPromise = DashboardSettingsService.query({
                            currentPage: drvCtrl.currentPage,
                            pageSize: drvCtrl.configuration.PageSize,
                            searchName: searchName
                        })
                            .then(getDashboardSettingsOk, getDashboardSettingsError)
                            .then(function () {
                                drvCtrl.loading = false;
                            });

                        updateList.currentPromise = getPromise;

                        return getPromise;

                        function getDashboardSettingsOk(data) {
                            if (getPromise === updateList.currentPromise) {
                                drvCtrl.error = null;
                                drvCtrl.dashboardSettings = data.DashboardSettings;
                                drvCtrl.dashboardSettingCount = data.DashboardSettingCount;
                            }
                            else {
                                return $q.reject();
                            }
                        }

                        function getDashboardSettingsError(response) {
                            if (getPromise === updateList.currentPromise) {
                                drvCtrl.error = response;
                            }
                            else {
                                return $q.reject();
                            }
                        }
                    }

                    function loadEntityTemplates() {
                        return EntityTemplatesService.query()
                            .then(getEntityTemplatesOk, getEntityTemplatesError);

                        function getEntityTemplatesOk(data) {
                            drvCtrl.entityTemplates = data.EntityTemplates;
                        }

                        function getEntityTemplatesError(response) {
                            DialogService.error('Error fetching Entity Templates', response);
                        }
                    }

                    /**
                     * Redirect to the create dashboard setting view
                     */
                    function newDashboardSetting() {
                        $location.url('/dashboardsettings/new');
                    }

                    function deleteDashboardSetting(dashboardSettingId) {
                        DialogService.confirm('Delete the selected Dashboard Panel?', 'Dashboard Panel delete confirm')
                            .then(deleteOk);

                        function deleteOk() {
                            DashboardSettingsService.remove(dashboardSettingId)
                                .then(deleteDashboardSettingOk, deleteDashboardSettingError);

                            function deleteDashboardSettingOk(success) {
                                drvCtrl.updateList();
                                loadCount();
                            }

                            function deleteDashboardSettingError(response) {
                                DialogService.error('Error deleting Dashboard Panel', response);
                            }
                        }
                    }

                    function loadCount() {
                        return DashboardSettingsService.count(drvCtrl.showDeleted)
                            .then(loadCountOk, loadCountError);

                        function loadCountOk(count) {
                            drvCtrl.totalCount = count;
                        }

                        function loadCountError(response) {
                            drvCtrl.error = 'Error fetching dashboard panel count.';
                        }
                    }

                    /*
                     * Get the user friendly name for the supplied dashboard setting
                     *
                     * @returns {string} - Returns user friendly dashboard name
                     */
                    function getDashboardSettingName(dashboardSetting) {
                        var name = '';

                        switch (dashboardSetting.Type) {
                            case 'Entities':
                                var entityTemplate = _.find(drvCtrl.entityTemplates, function (n) { return n.Id.toString() === dashboardSetting.EntityTemplateId.toString(); });

                                if (!_.isNil(entityTemplate)) {
                                    name = entityTemplate.PluralName;
                                }
                                break;
                        }

                        return name;
                    }

                    /*
                     * Get the user friendly description for the supplied dashboard setting
                     *
                     * @returns {string} - Returns user friendly dashboard setting description
                     */
                    function getDashboardSettingDescription(dashboardSetting) {
                        var description = '';

                        switch (dashboardSetting.Type) {
                            case 'Entities':
                                var entityTemplate = _.find(drvCtrl.entityTemplates, function (n) { return n.Id.toString() === dashboardSetting.EntityTemplateId; });

                                if (!_.isNil(entityTemplate)) {
                                    description = entityTemplate.Description;
                                }
                                break;
                        }

                        return description;
                    }

                    function orderDashboardSettings() {
                        DialogService.show({
                            locals: { entityTemplates: drvCtrl.entityTemplates },
                            controller: 'DashboardSettingOrderingCtrl',
                            controllerAs: 'vm',
                            templateUrl: 'app/dashboardsetting/dashboard-setting-ordering.tmpl.html'
                        })
                        .then(orderDashboardSettingsOk);

                        function orderDashboardSettingsOk(orderChanged) {
                            if (orderChanged) {
                                updateList();
                            }
                        }
                    }

                    /**
                     * When the view is 'closed' navigation to a previous page should occur.
                     */
                    function close() {
                        NavigationAidService.goBack();
                    }

                    /**
                     * Gets the view title
                     *
                     * @returns {string}
                     */
                    function getTitleText() {
                        var result = '';

                        if (drvCtrl.showDeleted === true) {
                            result += 'Deleted ';
                        }

                        result += 'Dashboard Panels';

                        return result;
                    }
                }],
                controllerAs: 'drvCtrl',
                bindToController: {
                    configuration: '=',
                    viewMode: '<?'
                }
            };
        });
})();